module.exports = __webpack_public_path__ + "static/AXLRY-TermsOfUse-12.3.18-26c0511263cbc09c36002a3fc77b6aef.pdf";